import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ProductPreview from '../product_preview/ProductPreview';
import './Products.sass';
import { productsActions } from '../../actions';
import Loader from '../../../checkout/components/loader/Loader';
import {
  productsLoadingSelector, productsObjectsSelector, productsPageSelector, productsHasMoreSelector,
} from '../../selectors/products';
import ga4DataLayer from '../../../services/ga4_datalayer';

function loadMoreProductsUrl(page) {
  const url = new URL(window.location.href);
  url.searchParams.set('format', 'json');
  url.searchParams.set('page', page);
  return url.href;
}

class Products extends Component {
  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    const { products, itemListId, itemListName } = this.props;
    if (products.length > 0) {
      ga4DataLayer.trackViewItemList(products, { itemListId, itemListName });
    }
    this.prevProductsLength = products.length;
  }

  componentDidUpdate() {
    const { products, itemListId, itemListName } = this.props;
    if (products.length > this.prevProductsLength) {
      const newProducts = products.slice(this.prevProductsLength);
      ga4DataLayer.trackViewItemList(newProducts, { itemListId, itemListName });
      this.prevProductsLength = products.length;
    }
  }

  handleScroll = () => {
    const {
      loading, loadMoreProducts, currentPage, hasMore, productsPerPage,
    } = this.props;

    if (!hasMore || loading) { return; }

    const lastProduct = document.querySelector('.products .product-preview:last-of-type');
    const lastProductOffset = lastProduct.offsetTop + lastProduct.clientHeight;
    const pageOffset = window.pageYOffset + window.innerHeight;
    if (pageOffset > lastProductOffset) {
      loadMoreProducts(loadMoreProductsUrl(currentPage + 1), currentPage, productsPerPage);
    }
  };

  render() {
    const {
      addToBag, loading, hasMore, products, showSkinType, itemListId, itemListName,
    } = this.props;

    const firstProducts = products.slice(0, 6);
    const bestSeller = products[6];
    let restProducts = products.slice(7);

    if (hasMore && restProducts.length % 6 !== 0) {
      restProducts = restProducts.slice(0, -(restProducts.length % 6));
    }

    return (
      <div className="products">
        <div className="list">
          { firstProducts.map((product, index) => (
            <ProductPreview
              key={product.id}
              product={product}
              addToBag={addToBag}
              showSkinType={showSkinType}
              itemListId={itemListId}
              itemListName={itemListName}
              index={index}
            />
          ))}
        </div>

        <div className="list">
          { bestSeller && (
            <>
              <div className="bestseller">
                BESTSELLER
              </div>
              <ProductPreview
                key={bestSeller.id}
                product={bestSeller}
                addToBag={addToBag}
                className="first"
                showSkinType={showSkinType}
                showPreviewText
                itemListId={itemListId}
                itemListName={itemListName}
                index={6}
              />
            </>
          )}
        </div>

        <div className="list">
          { restProducts.map((product, index) => (
            <ProductPreview
              key={product.id}
              product={product}
              addToBag={addToBag}
              showSkinType={showSkinType}
              itemListId={itemListId}
              itemListName={itemListName}
              index={index + 7}
            />
          ))}
        </div>

        { loading && <Loader /> }
      </div>
    );
  }
}

Products.propTypes = {
  addToBag: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  loadMoreProducts: PropTypes.func.isRequired,
  currentPage: PropTypes.number.isRequired,
  hasMore: PropTypes.bool.isRequired,
  products: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
  })).isRequired,
  productsPerPage: PropTypes.number.isRequired,
  showSkinType: PropTypes.bool.isRequired,
  itemListId: PropTypes.string,
  itemListName: PropTypes.string,
};

Products.defaultProps = {
  itemListId: 'plp',
  itemListName: 'Product List',
};

const mapStateToProps = (state) => ({
  products: productsObjectsSelector(state),
  loading: productsLoadingSelector(state),
  currentPage: productsPageSelector(state),
  hasMore: productsHasMoreSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  addToBag: (id) => dispatch(productsActions.addToBagRequest(id)),
  loadMoreProducts: (url, currentPage, productsPerPage) => {
    dispatch(productsActions.loadMoreProductsRequest({ url, currentPage, productsPerPage }));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Products);
